//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PageContent',
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      title: '',
      text: ''
    }
  },
  async fetch () {
    const res = await this.$axios.get(`/pages/${this.slug}`)
    this.title = res.data.data.title
    this.text = res.data.data.text
  }
}
